import { ReactNode, useEffect } from "react";
import { useRouter } from "next/router";
import NProgress from "nprogress";

interface RoutesLoadingProps {
  children: ReactNode | ReactNode[];
}

export default function RoutesLoading({ children }: RoutesLoadingProps) {
  const router = useRouter();

  NProgress.configure({
    easing: "ease",
    speed: 500,
    showSpinner: false,
  });

  useEffect(() => {
    const handleRouteChange = () => {
      NProgress.start();
    };

    const handleRouteDone = () => {
      NProgress.done();
    };

    router.events.on("routeChangeStart", handleRouteChange);
    router.events.on("routeChangeComplete", handleRouteDone);
    router.events.on("routeChangeError", handleRouteDone);
    router.events.on("routeChangeError", handleRouteDone);

    return () => {
      router.events.off("routeChangeStart", handleRouteDone);
      router.events.on("routeChangeComplete", handleRouteDone);
      router.events.on("routeChangeError", handleRouteDone);
    };
  }, [router.events]);
  return <>{children}</>;
}
